import React, {lazy} from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter, Navigate, Routes, Route} from "react-router-dom";
import {applyMiddleware, combineReducers, createStore} from "redux";
import * as serviceWorker from './serviceWorker';
import thunk from "redux-thunk";
import moment from "moment";
import * as t from "counterpart";
import {Provider} from "react-redux";
import reducer from "./reducer";
import storage from "./utilities/storage";
import apps from "./apps";
import Portal from './Portal';
import View from "./Layout/View";
import I18n from "./i18n.js";
import api from "./utilities/API.js";
import 'moment/locale/ar';

const Login = lazy(() => import("./Components/Login"));
const Account = lazy(() => import("./Components/Account"));
const AccountDevices = lazy(() => import("./Components/Account/Devices"));
const AccountNotifications = lazy(() => import("./Components/Account/notifications"));

// setting
window.portalSettingList = {};
window.portalSetting = function(name, defaultValue = "", i18n=true) {
    let v = window.portalSettingList[name] || defaultValue;
    if(name === "commerce.currency" && i18n) {
        return t(v);
    }

    return v;
}

// routes
let routes = [
    <Route key="page" path="*" element={<View />} />,
	<Route key="auth" path={`/auth/:page`} element={<Login />} />,
	<Route key="account" path={`/account`} element={<Account />} />,
	<Route key="account_devices" path={`/account/devices`} element={<AccountDevices />} />,
	<Route key="account-notifications" path={`/account/notifications`} element={<AccountNotifications />} />,
];

let reducers = {portal: reducer},
    translations = {},
    blocks = {};

// setup the apps
apps.forEach(app => {
    routes = [...routes, ...app.routes];
    reducers = {...reducers, ...app.reducers};
    blocks = {...blocks, ...app.blocks};
    translations.en = {...translations.en, ...app.i18n.en};
    translations.ar = {...translations.ar, ...app.i18n.ar};
});

window.viewBlocks = blocks;

//
translations.en = {...translations.en, ...I18n.en};
translations.ar = {...translations.ar, ...I18n.ar};
t.setLocale("ar");

// setup translations
t.registerTranslations("en", translations.en);
t.registerTranslations("ar", translations.ar);
t.setMissingEntryGenerator(function(key) {return key.split(".")[1].replace(/_/g, " ")});

// to avoid error on empty string
const f = t.Instance.prototype.translate;
t.Instance.prototype.translate = function(key, options) {
    return f.apply(this, [key || " ", options]);
}

//
const reduxStore = createStore(combineReducers(reducers), applyMiddleware(thunk));

const home = process.env.REACT_APP_DEFAULT_HOME || ""; // /pos | /confirmation
const render = (setting={}) =>
{
    // get locale and prefix
    const base = window.location.pathname;
    let locale = {};
    if(base === "/") {
        locale = storage("locale") || {};
    } else {
        const l = base.split("/")[1].split("-");
        locale = {store: l[0], lang: l[1]};

    }

    // lang
    if(locale.lang !== "ar" && locale.lang !== "en") {
        locale.lang = setting.default_language || "ar";
    }
    window.portal_lang = locale.lang;
    moment.locale(locale.lang);

    // set store id
    if(setting.stores) {
        let selectStore = setting.stores.find(s => (s.store_code === locale.store));
        if(!selectStore) {
            selectStore = setting.stores[0] || {};
        }

        window.portal_store_id = selectStore.id;
        if(!locale.store) {
            locale.store = selectStore.store_code;
        }
    }

    t.setLocale(locale.lang);
    storage("locale", locale);
    storage("lang", locale.lang, true);

    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(<Provider store={reduxStore}>
        <BrowserRouter>
            <Routes>
                <Route path="/" exact element={<Navigate to={"/"+locale.store+"-"+locale.lang+home} />}></Route>
                <Route path="/:store/*" element={<Portal routes={routes} />}></Route>
            </Routes>
        </BrowserRouter>
    </Provider>);
};

api("/init", {
    result: (setting) => {
        window.portalSettingList = setting || {};

        if(setting["web.script"]) {
            const newContent = document.createRange().createContextualFragment(setting["web.script"]);
            document.head.append(newContent);
        }

        if(setting["web.css"]) {
            document.head.appendChild(document.createElement("style")).innerHTML= setting["web.css"];
        }

        render(setting);
    },
    error: () => render()
});

serviceWorker.unregister();

// todo: generate public/manifest.json based on the app web/pos/confirmation
